<template>
  <div class="page-detail-lxgc">
    <!-- 基本信息 -->
    <div class="section-title">| 基本信息</div>
    <div class="section-body">
      <div class="info-row">
        <span class="info-field info-field-wrap">
          <span class="info-label">{{ detail.fromType === '1' ? '报修人姓名：' : '需求人姓名：' }}</span>
          <span class="info-value">{{ detail.requesterName || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">手机号：</span>
          <span class="info-value">{{ detail.phone || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">{{ detail.fromType === '1' ? '报修类型：' : '施工类型：' }}</span>
          <span class="info-value">{{ detail.bxlxName || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">报修地点：</span>
          <span class="info-value">{{ detail.address || '-' }}</span>
        </span>
        <span class="info-field info-field-wrap">
          <span class="info-label">详细地址：</span>
          <span class="info-value">{{ detail.detailAddress || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">供应商：</span>
          <span class="info-value">{{ detail.gysName || '-' }}</span>
        </span>
      </div>
      <div class="info-row-full">
        <span class="info-label">{{ detail.fromType === '1' ? '故障描述：' : '项目描述：' }}</span>
        <span class="info-value info-value-multiline">{{ detail.projectDescription || '-' }}</span>
      </div>
      <div class="info-row-full">
        <span class="info-label">{{ detail.fromType === '1' ? '报修图片：：' : '项目图片：' }}</span>
        <div class="img-list" v-if="imgList.length">
          <a-upload :file-list="imgList" list-type="picture-card" :show-upload-button="false" :disabled="true" @preview="handlePreview" />
        </div>
        <span v-else class="info-value">-</span>
      </div>
    </div>

    <!-- 报价分项信息 -->
    <template v-if="detail.bjStep === '1'">
      <div class="section-title">| 分项信息-报价</div>
      <div class="section-body">
        <div class="info-row-full">
          <span class="info-label">方案描述：</span>
          <span class="info-value info-value-multiline">{{ stageInfo.bj.solutionDescription || '-' }}</span>
        </div>
        <div class="info-row-full">
          <span class="info-label">方案文件：</span>
          <div v-if="stageInfo.bj.fileList && stageInfo.bj.fileList.length" class="file-list">
            <div v-for="(file, index) in stageInfo.bj.fileList" :key="index" class="file-item">
              <a :href="file.fileFullName" target="_blank" class="file-link">{{ file.fileName || '附件' }}</a>
            </div>
          </div>
          <span v-else class="info-value">-</span>
        </div>
        <div class="info-row-full" v-if="stageInfo.bj.startDate || stageInfo.bj.endDate">
          <span class="info-label">工期：</span>
          <span class="info-value">{{ stageInfo.bj.startDate }}至{{ stageInfo.bj.endDate }}</span>
        </div>
        <div class="table-wrapper">
          <a-table
            :columns="columns"
            :data-source="bjProjectList"
            :pagination="bjPagination"
            :row-key="(_, i) => String(i)"
            :scroll="{ x: 1120 }"
            bordered
            @change="p => handleProjectTableChange(p, 'bj')"
            style="margin-top: 16px;"
          >
            <template slot="index" slot-scope="text, record, index">
              {{ (bjPagination.current - 1) * bjPagination.pageSize + index + 1 }}
            </template>
            <template slot="isCenterPurchasingPrice" slot-scope="text">
              {{ text === '1' ? '是' : '否' }}
            </template>
            <template slot="projectCharacteristics" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
            <template slot="remark" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
          </a-table>
          <div class="total-row">合计（元）：{{ bjTotalPrice }}</div>
        </div>
      </div>

      <!-- 审核信息 -->
      <div class="section-title">| 审核信息-报价</div>
      <div class="section-body">
        <a-table
          :columns="auditColumns"
          :data-source="bjAuditList"
          :pagination="bjAuditPagination"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 680 }"
          bordered
          @change="p => handleAuditTableChange(p, 'bj')"
        >
          <template slot="auditStatus" slot-scope="text">
            {{ text === '1' ? '同意' : '驳回' }}
          </template>
          <template slot="auditDescription" slot-scope="text">
            <div class="audit-desc-cell">{{ text || '-' }}</div>
          </template>
          <template slot="auditFile" slot-scope="text, record">
            <a v-if="record.fileUrl" :href="record.fileUrl" target="_blank" class="file-link">{{ text || '附件' }}</a>
            <span v-else>-</span>
          </template>
        </a-table>
      </div>

      <!-- 相关资料 -->
      <div class="section-title">| 相关资料</div>
      <div class="section-body">
        <a-table
          :columns="relatedFileColumns"
          :data-source="relatedFileList"
          :pagination="false"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 660 }"
          bordered
        >
          <template slot="index" slot-scope="text, record, index">
            {{ (relatedFilePagination.current - 1) * relatedFilePagination.pageSize + index + 1 }}
          </template>
          <template slot="description" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
          <template slot="fileAction" slot-scope="text, record">
            <a v-if="record.fileUrl" href="javascript:;" class="file-link" @click="handleViewFile(record)">查看</a>
            <span v-else>-</span>
          </template>
        </a-table>
        <div class="pagination-wrapper">
          <a-pagination
            :current="relatedFilePagination.current"
            :total="relatedFilePagination.total"
            :pageSize="relatedFilePagination.pageSize"
            :pageSizeOptions="relatedFilePagination.pageSizeOptions"
            :showTotal="relatedFilePagination.showTotal"
            showSizeChanger
            showQuickJumper
            @change="handleRelatedFilePageChange"
            @showSizeChange="handleRelatedFileSizeChange"
          />
        </div>
      </div>

      <!-- 查看文件弹窗 -->
      <a-modal
        title="查看"
        :visible="fileModalVisible"
        :footer="null"
        :width="700"
        wrapClassName="lxgc-file-view-modal"
        @cancel="fileModalVisible = false"
      >
        <a-table
          :columns="fileModalColumns"
          :data-source="fileModalPagedList"
          :pagination="false"
          :row-key="(_, i) => String(i)"
          bordered
        >
          <template slot="fileModalIndex" slot-scope="text, record, index">
            {{ (fileModalPage - 1) * fileModalPageSize + index + 1 }}
          </template>
          <template slot="fileModalAction" slot-scope="text, record">
            <a href="javascript:;" class="file-link" @click="handlePreviewFile(record)">预览</a>
            <a href="javascript:;" class="file-link" style="margin-left: 16px;" @click="handleDownloadFile(record)">下载</a>
          </template>
        </a-table>
        <div class="pagination-wrapper">
          <a-pagination
            v-model="fileModalPage"
            :total="fileModalList.length"
            :pageSize="fileModalPageSize"
            :page-size-options="['10', '20', '50', '100']"
            :show-total="total => `总共${total}条数据`"
            show-size-changer
            show-quick-jumper
            @change="p => fileModalPage = p"
            @showSizeChange="(c, s) => { fileModalPage = 1; fileModalPageSize = s }"
          />
        </div>
      </a-modal>

      <!-- 图片预览弹窗 -->
      <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="previewVisible = false"
      >
        <img :src="previewImage" style="width: 100%;" />
      </a-modal>
    </template>

    <!-- 变更分项信息 -->
    <template v-if="showBg">
      <div class="section-title">| 分项信息-工程变更</div>
      <div class="section-body">
        <div class="info-row-full">
          <span class="info-label">方案描述：</span>
          <span class="info-value info-value-multiline">{{ stageInfo.bg.solutionDescription || '-' }}</span>
        </div>
        <div class="info-row-full">
          <span class="info-label">方案文件：</span>
          <div v-if="stageInfo.bg.fileList && stageInfo.bg.fileList.length" class="file-list">
            <div v-for="(file, index) in stageInfo.bg.fileList" :key="index" class="file-item">
              <a :href="file.fileFullName" target="_blank" class="file-link">{{ file.fileName || '附件' }}</a>
            </div>
          </div>
          <span v-else class="info-value">-</span>
        </div>
        <div class="info-row-full" v-if="stageInfo.bg.startDate || stageInfo.bg.endDate">
          <span class="info-label">工期：</span>
          <span class="info-value">{{ stageInfo.bg.startDate }}至{{ stageInfo.bg.endDate }}</span>
        </div>
        <div class="table-wrapper">
          <a-table
            :columns="columns"
            :data-source="bgProjectList"
            :pagination="bgPagination"
            :row-key="(_, i) => String(i)"
            :scroll="{ x: 1120 }"
            bordered
            @change="p => handleProjectTableChange(p, 'bg')"
            style="margin-top: 16px;"
          >
            <template slot="index" slot-scope="text, record, index">
              {{ (bgPagination.current - 1) * bgPagination.pageSize + index + 1 }}
            </template>
            <template slot="isCenterPurchasingPrice" slot-scope="text">
              {{ text === '1' ? '是' : '否' }}
            </template>
            <template slot="projectCharacteristics" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
            <template slot="remark" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
          </a-table>
          <div class="total-row">合计（元）：{{ bgTotalPrice }}</div>
        </div>
      </div>

      <!-- 变更审核信息 -->
      <div class="section-title">| 审核信息-工程变更</div>
      <div class="section-body">
        <a-table
          :columns="auditColumnsNoFile"
          :data-source="bgAuditList"
          :pagination="bgAuditPagination"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 560 }"
          bordered
          @change="p => handleAuditTableChange(p, 'bg')"
        >
          <template slot="auditStatus" slot-scope="text">
            {{ text === '1' ? '同意' : '驳回' }}
          </template>
          <template slot="auditDescription" slot-scope="text">
            <div class="audit-desc-cell">{{ text || '-' }}</div>
          </template>
        </a-table>
      </div>
    </template>

    <!-- 验收分项信息 -->
    <template v-if="showYs">
      <div class="section-title">| 分项信息-验收</div>
      <div class="section-body">
        <!-- <div class="info-row-full">
          <span class="info-label">方案描述：</span>
          <span class="info-value info-value-multiline">{{ stageInfo.ys.solutionDescription || '-' }}</span>
        </div>
        <div class="info-row-full">
          <span class="info-label">方案文件：</span>
          <a v-if="stageInfo.ys.fileUrl" :href="stageInfo.ys.fileUrl" target="_blank" class="file-link">{{ stageInfo.ys.fileName || '附件' }}</a>
          <span v-else class="info-value">-</span>
        </div>
        <div class="info-row-full" v-if="stageInfo.ys.startDate || stageInfo.ys.endDate">
          <span class="info-label">工期：</span>
          <span class="info-value">{{ stageInfo.ys.startDate }}至{{ stageInfo.ys.endDate }}</span>
        </div> -->
        <div class="table-wrapper">
          <a-table
            :columns="columns"
            :data-source="ysProjectList"
            :pagination="ysPagination"
            :row-key="(_, i) => String(i)"
            :scroll="{ x: 1120 }"
            bordered
            @change="p => handleProjectTableChange(p, 'ys')"
            style="margin-top: 16px;"
          >
            <template slot="index" slot-scope="text, record, index">
              {{ (ysPagination.current - 1) * ysPagination.pageSize + index + 1 }}
            </template>
            <template slot="isCenterPurchasingPrice" slot-scope="text">
              {{ text === '1' ? '是' : '否' }}
            </template>
            <template slot="projectCharacteristics" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
            <template slot="remark" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
          </a-table>
          <div class="total-row">合计（元）：{{ ysTotalPrice }}</div>
        </div>
      </div>

      <!-- 验收审核信息 -->
      <div class="section-title">| 审核信息-验收</div>
      <div class="section-body">
        <a-table
          :columns="auditColumnsNoFile"
          :data-source="ysAuditList"
          :pagination="ysAuditPagination"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 560 }"
          bordered
          @change="p => handleAuditTableChange(p, 'ys')"
        >
          <template slot="auditStatus" slot-scope="text">
            {{ text === '1' ? '同意' : '驳回' }}
          </template>
          <template slot="auditDescription" slot-scope="text">
            <div class="audit-desc-cell">{{ text || '-' }}</div>
          </template>
        </a-table>
      </div>
    </template>

    <!-- 底部返回按钮 -->
    <div class="back-button-wrapper">
      <a-button @click="handleBack">返回</a-button>
    </div>

    <!-- 图片预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img style="width: 100%;" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
function makePagination () {
  return {
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: total => `总共${total}条数据`,
    showSizeChanger: true,
    showQuickJumper: true,
    hideOnSinglePage: false,
    pageSizeOptions: ['10', '20', '50']
  }
}

export default {
  name: 'LxgcDetail',
  data () {
    return {
      detail: {},
      // 三阶段方案信息（方案描述/工期/方案文件），由 /lxgc/stageInfoList.do 一次性加载
      stageInfo: {
        bj: { solutionDescription: '', startDate: '', endDate: '', fileList: [] },
        bg: { solutionDescription: '', startDate: '', endDate: '', fileList: [] },
        ys: { solutionDescription: '', startDate: '', endDate: '', fileList: [] }
      },
      imgList: [],
      previewVisible: false,
      previewImage: '',
      bjProjectList: [],
      bgProjectList: [],
      ysProjectList: [],
      bjTotalPrice: '0.00',
      bgTotalPrice: '0.00',
      ysTotalPrice: '0.00',
      bjPagination: makePagination(),
      bgPagination: makePagination(),
      ysPagination: makePagination(),
      allAuditList: [],
      bjAuditList: [],
      bgAuditList: [],
      ysAuditList: [],
      bjAuditPagination: makePagination(),
      bgAuditPagination: makePagination(),
      ysAuditPagination: makePagination(),
      relatedFileList: [],
      relatedFilePagination: makePagination(),
      relatedFileColumns: [
        { title: '序号', scopedSlots: { customRender: 'index' }, width: 60, align: 'center' },
        { title: '描述', dataIndex: 'description', scopedSlots: { customRender: 'description' }, width: 200, align: 'center' },
        { title: '时间', dataIndex: 'createDate', width: 180, align: 'center' },
        { title: '操作人', dataIndex: 'operatorName', width: 120, align: 'center' },
        { title: '文件', scopedSlots: { customRender: 'fileAction' }, width: 100, align: 'center' }
      ],
      fileModalVisible: false,
      fileModalList: [],
      fileModalPage: 1,
      fileModalPageSize: 10,
      fileModalColumns: [
        { title: '序号', scopedSlots: { customRender: 'fileModalIndex' }, width: 60, align: 'center' },
        { title: '文件', dataIndex: 'description', align: 'center' },
        { title: '操作', scopedSlots: { customRender: 'fileModalAction' }, width: 160, align: 'center' }
      ],
      columns: [
        { title: '序号', scopedSlots: { customRender: 'index' }, width: 60, align: 'center' },
        { title: '是否集采价', dataIndex: 'isCenterPurchasingPrice', scopedSlots: { customRender: 'isCenterPurchasingPrice' }, width: 100, align: 'center' },
        { title: '分项工程名称', dataIndex: 'projectName', width: 150, align: 'center' },
        { title: '项目特征描述', dataIndex: 'projectCharacteristics', scopedSlots: { customRender: 'projectCharacteristics' }, width: 200, align: 'center' },
        { title: '单位', dataIndex: 'unit', width: 80, align: 'center' },
        { title: '工程量', dataIndex: 'projectQuantity', width: 80, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'price', width: 180, align: 'center' },
        { title: '含税合价（元）', dataIndex: 'totalPrice', width: 120, align: 'center' },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, width: 150, align: 'center' }
      ],
      auditColumns: [
        { title: '审核人', dataIndex: 'auditor', width: 100, align: 'center' },
        { title: '审核时间', dataIndex: 'auditDate', width: 160, align: 'center' },
        { title: '审核结果', dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' }, width: 100, align: 'center' },
        { title: '审核意见', dataIndex: 'auditDescription', scopedSlots: { customRender: 'auditDescription' }, width: 200, align: 'center' },
        { title: '附件', dataIndex: 'fileName', scopedSlots: { customRender: 'auditFile' }, width: 120, align: 'center' }
      ],
      auditColumnsNoFile: [
        { title: '审核人', dataIndex: 'auditor', width: 100, align: 'center' },
        { title: '审核时间', dataIndex: 'auditDate', width: 160, align: 'center' },
        { title: '审核结果', dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' }, width: 100, align: 'center' },
        { title: '审核意见', dataIndex: 'auditDescription', scopedSlots: { customRender: 'auditDescription' }, width: 200, align: 'center' }
      ]
    }
  },
  computed: {
    showBg () {
      // 提交过变更（bgStep=1）或已审批完成（有审批记录或审批结果）都展示变更区块
      return this.detail.bgStep === '1' ||
        this.detail.bgAuditStatus === '1' || this.detail.bgAuditStatus === '-1' ||
        (this.bgAuditList && this.bgAuditList.length > 0) ||
        (this.bgProjectList && this.bgProjectList.length > 0)
    },
    showYs () {
      return this.detail.ysStep === '1'
    },
    fileModalPagedList () {
      const start = (this.fileModalPage - 1) * this.fileModalPageSize
      return this.fileModalList.slice(start, start + this.fileModalPageSize)
    }
  },
  mounted () {
    const id = this.$route.query.id
    if (id) {
      // 简化为 5 个接口：detail.do + relatedFileList.do + 三个合并接口
      this.$axios.post('/api/lxgc/detail.do', { id }).then(res => {
        this.detail = (res.data && res.data.data) || {}
        const imgList = (res.data && res.data.imgList) || []
        this.imgList = imgList.map((item, i) => ({
          uid: item.id || String(i),
          name: item.fileName || `图片${i + 1}`,
          status: 'done',
          thumbUrl: item.fileFullName,
          url: item.fileFullName
        }))
      })
      this.loadStageInfo()
      this.loadAllProjectList()
      this.loadAllAuditList()
      this.loadRelatedFileList()
    }
  },
  methods: {
    /** 一次性加载三个阶段的方案描述 / 工期 / 方案文件 */
    loadStageInfo () {
      this.$axios.post('/api/lxgc/stageInfoList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        const apply = (stage) => {
          const info = data[stage] || {}
          this.$set(this.stageInfo, stage, {
            solutionDescription: info.solutionDescription || '',
            startDate: info.startDate || '',
            endDate: info.endDate || '',
            fileList: info.fileList || []
          })
        }
        apply('bj')
        apply('bg')
        apply('ys')
      })
    },
    /** 一次性加载三个阶段的分项工程列表 */
    loadAllProjectList () {
      this.$axios.post('/api/lxgc/allProjectList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        this.bjProjectList = data.bj || []
        this.bgProjectList = data.bg || []
        this.ysProjectList = data.ys || []
        this.bjPagination = { ...this.bjPagination, total: this.bjProjectList.length }
        this.bgPagination = { ...this.bgPagination, total: this.bgProjectList.length }
        this.ysPagination = { ...this.ysPagination, total: this.ysProjectList.length }
        this.bjTotalPrice = this.calcStageTotal(this.bjProjectList)
        this.bgTotalPrice = this.calcStageTotal(this.bgProjectList)
        this.ysTotalPrice = this.calcStageTotal(this.ysProjectList)
      })
    },
    calcStageTotal (list) {
      // 使用字符串加法处理大数，避免 IEEE 754 精度丢失（如 11111111100000000 + 5 = 11111111100000004）
      // 将金额规整为两位小数的整数字符串（cents），逐位相加后再还原为 xxx.xx 形式
      const toCents = (val) => {
        if (val === null || val === undefined || val === '') return '0'
        const str = String(val).trim()
        if (!/^-?\d+(\.\d+)?$/.test(str)) return '0'
        const negative = str.startsWith('-')
        const abs = negative ? str.slice(1) : str
        const [intPart, decPart = ''] = abs.split('.')
        const dec2 = (decPart + '00').slice(0, 2)
        const combined = ((intPart || '0') + dec2).replace(/^0+(?=\d)/, '')
        return negative ? '-' + combined : combined
      }
      const addStrings = (a, b) => {
        // 只处理非负字符串加法（本场景 totalPrice 均为非负）
        const aa = a.replace(/^-/, '')
        const bb = b.replace(/^-/, '')
        let i = aa.length - 1
        let j = bb.length - 1
        let carry = 0
        let out = ''
        while (i >= 0 || j >= 0 || carry) {
          const x = i >= 0 ? aa.charCodeAt(i--) - 48 : 0
          const y = j >= 0 ? bb.charCodeAt(j--) - 48 : 0
          const s = x + y + carry
          carry = s >= 10 ? 1 : 0
          out = (s % 10) + out
        }
        return out
      }
      const formatCents = (cents) => {
        const s = cents.padStart(3, '0')
        return s.slice(0, -2) + '.' + s.slice(-2)
      }
      const sum = (list || []).reduce((acc, row) => addStrings(acc, toCents(row.totalPrice)), '0')
      return formatCents(sum)
    },
    handleProjectTableChange (pager, stage) {
      const paginationKey = stage + 'Pagination'
      this[paginationKey] = { ...this[paginationKey], current: pager.current, pageSize: pager.pageSize }
    },
    /** 一次性加载三个阶段的审批记录 */
    loadAllAuditList () {
      this.$axios.post('/api/lxgc/allAuditList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        this.bjAuditList = data.bj || []
        this.bgAuditList = data.bg || []
        this.ysAuditList = data.ys || []
        this.bjAuditPagination = { ...this.bjAuditPagination, total: this.bjAuditList.length }
        this.bgAuditPagination = { ...this.bgAuditPagination, total: this.bgAuditList.length }
        this.ysAuditPagination = { ...this.ysAuditPagination, total: this.ysAuditList.length }
      })
    },
    handleAuditTableChange (pager, stage) {
      const paginationKey = stage + 'AuditPagination'
      this[paginationKey] = { ...this[paginationKey], current: pager.current, pageSize: pager.pageSize }
    },
    handlePreview (file) {
      this.previewImage = file.url
      this.previewVisible = true
    },
    loadRelatedFileList () {
      const { current, pageSize } = this.relatedFilePagination
      this.$axios.post('/api/lxgc/relatedFileList.do', {
        lxgcId: this.$route.query.id,
        currentPageNo: current,
        pageSize
      }).then(res => {
        const list = (res.data && res.data.list) || []
        // 适配字段：createTime → createDate，fileList → fileUrl
        this.relatedFileList = list.map(item => ({
          ...item,
          createDate: item.createTime || item.createDate || '',
          operatorName: item.operatorName || item.gysName || '',
          fileUrl: item.fileList && item.fileList.length > 0 ? item.fileList[0].fileUrl : '',
          fileAddress: item.fileList && item.fileList.length > 0 ? item.fileList[0].fileAddress : ''
        }))
        this.relatedFilePagination = { ...this.relatedFilePagination, total: res.total || 0 }
      })
    },
    handleRelatedFileTableChange (pager) {
      this.relatedFilePagination = { ...this.relatedFilePagination, current: pager.current, pageSize: pager.pageSize }
      this.loadRelatedFileList()
    },
    handleRelatedFilePageChange (page, pageSize) {
      this.relatedFilePagination = { ...this.relatedFilePagination, current: page, pageSize }
      this.loadRelatedFileList()
    },
    handleRelatedFileSizeChange (current, size) {
      this.relatedFilePagination = { ...this.relatedFilePagination, current: 1, pageSize: size }
      this.loadRelatedFileList()
    },
    handleViewFile (record) {
      // 调用新接口根据资料ID获取完整文件列表
      this.$axios.post('/api/lxgc/fileListByRefId.do', {
        id: record.id
      }).then(res => {
        const fileList = (res.data && res.data.list) || []
        this.fileModalList = fileList.map(file => ({
          ...file,
          description: file.fileName || file.description || '附件',
          fileUrl: file.fileUrl || file.fileFullName || '',
          fileAddress: file.fileAddress || ''
        }))
        this.fileModalPage = 1
        this.fileModalVisible = true
      }).catch(() => {
        this.$message.error('获取文件列表失败')
      })
    },
    handlePreviewFile (record) {
      const previewUrl = record.fileFullName || record.fileUrl
      if (!previewUrl) return
      const url = previewUrl.toLowerCase()
      if (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png') || url.endsWith('.gif') || url.endsWith('.bmp')) {
        this.previewImage = previewUrl
        this.previewVisible = true
      } else {
        window.open(previewUrl, '_blank')
      }
    },
    handleDownloadFile (record) {
      if (!record.fileAddress && !record.fileUrl) return
      // 通过后端 /file/download.do 代理下载，强制 attachment 触发浏览器另存为
      const env = process.env.NODE_ENV
      const url = env === 'production' ? '/file/download.do' : '/api/file/download.do'
      const address = record.fileAddress || this.extractAddressFromUrl(record.fileUrl)
      const fileName = record.description || '附件'
      this.downloadByForm(url, { address, fileName })
    },
    /** 从完整 URL 中提取相对路径（兜底，应优先使用后端返回的 fileAddress） */
    extractAddressFromUrl (fullUrl) {
      if (!fullUrl) return ''
      const idx = fullUrl.indexOf('group')
      return idx >= 0 ? fullUrl.substring(idx) : fullUrl
    },
    downloadByForm (url, data) {
      const form = document.createElement('form')
      form.action = url
      form.method = 'post'
      for (const key in data) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = data[key]
        form.appendChild(input)
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    handleBack () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.page-detail-lxgc {
  background: #fff;
  padding: 24px;
  min-height: calc(100vh - 64px);

  .section-title {
    color: #1890ff;
    font-size: 14px;
    margin-bottom: 16px;
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }
  }

  .section-body {
    padding: 0 0 16px 16px;

    .info-row {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      margin-bottom: 16px;

      .info-field {
        margin-right: 48px;
        margin-bottom: 8px;
      }

      .info-field-wrap {
        display: inline-flex;
        align-items: flex-start;
        max-width: 100%;

        .info-value {
          word-break: break-all;
          white-space: normal;
        }
      }
    }

    .info-row-full {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      flex-wrap: wrap;
    }

    .info-label {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      white-space: nowrap;
    }

    .info-value {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
    }

    .info-value-multiline {
      word-break: break-all;
      white-space: pre-wrap;
      flex: 1;
      max-width: calc(100% - 100px);
    }

    .audit-desc-cell {
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
      text-align: left;
      min-width: 150px;
    }

    .cell-multiline {
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
      text-align: left;
      min-width: 120px;
    }

    .file-link {
      color: #1890ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .file-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 4px;

      .file-item {
        display: flex;
        align-items: center;
      }
    }

    .img-list {
      margin-top: 4px;
    }
  }

  .table-wrapper {
    position: relative;
    margin-top: 16px;

    .total-row {
      position: absolute;
      bottom: 10px;
      left: 0;
      line-height: 32px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }

  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }

  .back-button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    padding-bottom: 24px;
  }
}
</style>

<style lang="less">
.lxgc-file-view-modal {
  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
